export default "__VITE_ASSET__DPmVOtXt__"